export default __webpack_public_path__ + "static/media/typeL_low_lamp.67ab90a2.png";